import React, { useEffect, useState, useLayoutEffect } from "react";
import { getCartItems } from "../../../service/cartService";
import { Share } from '@capacitor/share';
import { isAuth } from "../../../helpers/general";

import './header.css';
const HeaderMobile = ({ Type = "Header1", showBanner = false, linkBanner = "", showText = false, showSearch = false, showSearchIcon = true, showNoti = true, showCart = true, showBack = false, showTitle = "", showshare = false }) => {
    const [scrollPosition, setPosition] = useState(0);
    useLayoutEffect(() => {
        function updatePosition() {
            setPosition(window.pageYOffset);
            window.localStorage.setItem("scrollPosition", window.pageYOffset);
        }
        window.addEventListener('scroll', updatePosition);
        updatePosition();

        return () => window.removeEventListener('scroll', updatePosition);
    }, []);
    const [count_cart, setCountCart] = useState(0);
    const loadCart = () => {
        try {
            if (window.localStorage.getItem('key') !== '') {
                getCartItems(window.localStorage.getItem('key')).then((response) => {
                    localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    let CartItems = response['message'];
                    if (response['message'] === 'Yêu cầu không hợp lệ' || response.status === 400 || response.status === 500) {
                        localStorage.setItem('itemsCart', null);
                        CartItems = [];
                        return;
                    }
                    setCountCart(CartItems?.length ?? 0);
                });
            }

        } catch (err) {
            console.error(err);
        }
    }
    const [shareUrl, setShareUrl] = useState('');
    const [loadIntervel, setLoadINtervel] = useState(false);
    useEffect(() => {
        loadCart();
        setShareUrl(window.location.href + '?userReferral=' + window.localStorage.getItem('_id'));
        setLoadINtervel(true);
    }, []);

  const call =  setInterval(() => {
        try{
            if(loadIntervel === true){
                if(window.localStorage.getItem('key') !== null && window.localStorage.getItem('itemsCart') !== null && window.localStorage.getItem('itemsCart') !== "Yêu cầu không hợp lệ") {
                    let _count = JSON.parse(localStorage.getItem('itemsCart'));
                    setCountCart(_count?.length);
                }else{
                    setCountCart(0);
                }
            }    
            clearInterval(call);        
        }catch(e){clearInterval(call); console.log(e)}
    }, 10000);

    const handandleRedirect = (uri) => {
        if(uri === '/ket-qua-tim-kiem.html'){
            window.localStorage.removeItem('keysearchcurrent')
        }
        window.location.href = uri;
    }
    const handandleRedirectNoti = () => {
        if(isAuth() === true){
            window.location.href = '/mobile/noti.html';
        }else{
            window.location.href = '/dang-nhap.html';
        }
    }
    const handleBack = () => {

        // if(document.referrer.includes('/mobile/') === false){
        //     window.location.href = '/';
        // }else{
        //     if(document.referrer && document.referrer !== ''){
        //         window.history.back();
        //     }else{
        //         window.location.href = '/';
        //     }
        // }
        if(document.referrer && document.referrer !== ''){
            window.history.back();
        }else{
            window.location.href = '/';
        }
        
    }
    const [showShare, setShowShare] = useState(false);
    const setShowShareDefaut = () => {
        Share.share({
            title: window.localStorage.getItem('name_product'),
            text: window.localStorage.getItem('name_product'),
            url: shareUrl,
            dialogTitle: shareUrl,
        });
    }
    return (
        <>
            <div className={scrollPosition > 35 ? ("fixed") : ("")}>
                {
                    Type === "Header1" ? (
                        <div className="row header headerv2 pdx-10 mgx-0">
                            <div className={showSearchIcon === false && showNoti === false && showCart === false ? "col-12 header-left" : (scrollPosition <= 35 ? "col-9 header-left" : "col-10 header-left")}>
                                {
                                    scrollPosition <= 35 ? (<span className="select active">Khuyến mại</span>) : (null)
                                }
                                {
                                    showBack === true ? (<i onClick={handleBack} className="fa fa-chevron-left"></i>) : (null)
                                }
                                {
                                    scrollPosition > 35 ? (
                                        <div className="box-search in-f">
                                            <img className="mgr-10" onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>
                                            <input onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} className="search-input" type="text" placeholder="Ba Mẹ cần tìm gì cho bé hôm nay?" />
                                        </div>) : (null)
                                }
                            </div>
                            {
                                showSearchIcon === true && showNoti === true && showCart === true ? (
                                    <div className={scrollPosition <= 35 ? "col-3 pdx-0 in-jus" : "col-2 pdx-0 in-jus"}>
                                        {
                                            showSearchIcon === true && scrollPosition <= 35 ? (<img onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>) : (null)
                                        }
                                        {
                                            showNoti === true ? (<img onClick={() => handandleRedirectNoti()} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/notification_black.png" alt="icon"/>) : (null)
                                        }
                                        {
                                            showCart === true ? (
                                                <div className="cart-header">
                                                    <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon" style={{width:24, height:24}}/>
                                                    <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                                                </div>
                                            ) : (null)
                                        }
                                    </div>
                                ) : (null)
                            }
                        </div>
                    ) : (null)
                }
                {
                    Type === "Header2" ? (

                        <div className="row header-product-main pdy-10 bg-white mgx-0 pdx-10">
                            <div  onClick={handleBack} className="col-2 header-left in-f">
                                <i className="fa-solid fa-chevron-left"></i>
                            </div>
                            <div className="col-7 header-center in-f">
                                <span>{showTitle}</span>
                            </div>
                            <div className="col-3 pdx-0 in-jus">
                                {
                                    showSearchIcon === true ? (<img onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>) : (null)
                                }
                                {
                                    showCart === true ? (
                                        <div className="cart-header">
                                            <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon" style={{width:24, height:24}}/>
                                            <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                                        </div>
                                    ) : (null)

                                }
                                {
                                    showshare === true ? (<img onClick={() => setShowShareDefaut()} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_share_black.png" alt="icon"/>) : (null)
                                }
                            </div>
                        </div>

                    ) : (null)
                }
                {
                    Type === "headerInclude" ? (
                        <div className={scrollPosition < 35 ? ("row header-product-main mgt-10 header-include mgx-0 pdx-10") : ("row header-product-main pdy-10 mgx-0 pdx-10")}>
                            <div className="col-2 header-left pdl-10" onClick={handleBack}>
                                <i className={scrollPosition < 35 ? ("fa-solid fa-chevron-left text-color-white") : ("fa-solid fa-chevron-left")}></i>
                            </div>
                            <div className="col-7 header-center in-f pdx-0">
                                {
                                    scrollPosition > 35 ? (<span className={scrollPosition < 35 ? ("text-color-white") : (null)}>{showTitle}</span>) : (null)
                                }

                            </div>
                            {
                                scrollPosition < 35 ? (
                                    <div className="col-3 in-jus pdx-0">
                                        <img onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search.png" alt="icon"/>
                                        <div className="cart-header">
                                            <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header.png" alt="icon" style={{width:24, height:24}}/>
                                            <div onClick={() => handandleRedirect('/cart.html')} className="count_cart_white in-f">{count_cart ?? 0}</div>
                                        </div>

                                        <img onClick={() => setShowShareDefaut()} src={scrollPosition > 35 ? ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_share_black.png") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_share.png")} alt="icon"/>
                                    </div>
                                ) : (
                                    <div className="col-3 in-jus pdx-0">
                                        <img onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>
                                        <div className="cart-header">
                                            <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon"/>
                                            <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                                        </div>

                                        <img onClick={() => setShowShareDefaut()} src={scrollPosition > 35 ? ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_share_black.png") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_share_black.png")} alt="icon"/>
                                    </div>
                                )
                            }

                        </div>
                    ) : (null)
                }
                {
                    Type === "headerShowInputSearch" ? (
                        <div className="row header clearfix filter pdx-10 mgx-0">
                            <div className="col-10 header-left pdx-10">
                                <div className="box-search search-showsearch in-f">
                                    <img className="pdx-10" onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>
                                    <input onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} className="search-input" type="text" placeholder="Ba Mẹ cần tìm gì cho bé hôm nay?" />
                                </div>
                            </div>
                            <div className="col-2 in-jus pdx-0">
                                <img onClick={() => handandleRedirectNoti()} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/notification_black.png" alt="icon"/>
                                <div className="cart-header">
                                    <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon" style={{width:24, height:24}}/>
                                    <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                                </div>
                            </div>
                        </div>
                    ) : (null)
                }
                {
                    Type === "headerDanhMuc" ? (
                        <div className="row header headerDanhMuc clearfix filter in-f pdy-10 pdx-10 mgx-0">
                            <div onClick={handleBack} className="col-1 pdx-0">
                                <i className="fa fa-chevron-left"></i>
                            </div>
                            <div className="col-9 pdx-0">
                                <div className="box-search search-showsearch in-f">
                                    <img onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>
                                    <input onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} className="search-input" type="text" placeholder="Ba Mẹ cần tìm gì cho bé hôm nay?" />
                                </div>
                            </div>
                            <div className="col-2 pdx-0 header-right">
                                <div className="cart-header">
                                    <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon" style={{width:24, height:24}}/>
                                    <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                                </div>
                            </div>
                        </div>
                    ) : (null)
                }
                {
                    Type === "HeaderDacQuyen" ? (

                        <div className="row header-product-main bg-white pdy-10 pdx-10 mgx-0">
                            <div className="col-2 in-f pdx-0">
                            </div>
                            <div className="col-8 in-f pdx-0">
                                <span>{showTitle}</span>
                            </div>
                            <div className="col-2 in-jus pdx-0">
                                <img onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>
                                <div className="cart-header">
                                    <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon" style={{width:24, height:24}}/>
                                    <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                                </div>

                            </div>
                        </div>

                    ) : (null)
                }
                {
                    Type === "HeaderDetailProduct" ? (

                        <div className="row header-product-main pdy-10 bg-white pdx-10 mgx-0 clearfix">
                            <div className="col-2 header-left pdx-0 in-jus">
                                <i onClick={handleBack} className="fa-solid fa-chevron-left mgr-10"></i>
                                <img onClick={() => handandleRedirect('/ket-qua-tim-kiem.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/search_black.png" alt="icon"/>
                            </div>
                            <div className="col-8 header-center in-f">
                                <span>{showTitle}</span>
                            </div>
                            <div className="col-2 pdx-0 in-jus">
                                <div className="cart-header">
                                    <img className="icon-cart" onClick={() => handandleRedirect('/cart.html')} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/cart_header_black.png" alt="icon" style={{width:24, height:24}}/>
                                    <div onClick={() => handandleRedirect('/cart.html')} className="count_cart in-f">{count_cart ?? 0}</div>
                                </div>
                                {
                                    showCart === true ? (<img onClick={() => setShowShareDefaut()} src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_share_black.png" alt="icon"/>) : (null)
                                }
                            </div>
                        </div>

                    ) : (null)
                }
            </div>

            {/* {
                showShare ? (
                    <Share setShowShare={setShowShare} key={shareUrl} shareUrl={shareUrl}/>
                ) : (null)
            } */}
        </>
    )
}
export default HeaderMobile